export type HeaderPopoverPanelTab = 'history' | 'inspiration' | 'chat'
export type HeaderPopoverPanelCategory = 'all' | 'IMAGE' | 'VIDEO' | 'TOOL' | 'MUSIC'
export type HeaderPopoverPanelTargetPath =
    | '/image-to-image'
    | '/image-to-video'
    | '/text-to-music'

export type HeaderPopoverPanelHandoff = {
    targetPath: HeaderPopoverPanelTargetPath
    tab: HeaderPopoverPanelTab
    category: HeaderPopoverPanelCategory
    ts: number
}

const HEADER_POPOVER_PANEL_HANDOFF_KEY = 'header_popover_panel_handoff'

export const writeHeaderPopoverPanelHandoff = (
    payload: Omit<HeaderPopoverPanelHandoff, 'ts'>
) => {
    if (!import.meta.client || typeof window === 'undefined') return
    try {
        const handoff: HeaderPopoverPanelHandoff = {
            ...payload,
            ts: Date.now(),
        }
        window.sessionStorage.setItem(
            HEADER_POPOVER_PANEL_HANDOFF_KEY,
            JSON.stringify(handoff)
        )
        return handoff
    } catch {
        return
    }
}

export const consumeHeaderPopoverPanelHandoff = (
    expectedPath: HeaderPopoverPanelTargetPath
) => {
    if (!import.meta.client || typeof window === 'undefined') return null
    try {
        const raw = window.sessionStorage.getItem(HEADER_POPOVER_PANEL_HANDOFF_KEY)
        if (!raw) return null

        window.sessionStorage.removeItem(HEADER_POPOVER_PANEL_HANDOFF_KEY)

        const parsed = JSON.parse(raw) as Partial<HeaderPopoverPanelHandoff>
        if (
            !parsed ||
            parsed.targetPath !== expectedPath ||
            typeof parsed.ts !== 'number'
        ) {
            return null
        }

        if (
            parsed.tab !== 'history' &&
            parsed.tab !== 'inspiration' &&
            parsed.tab !== 'chat'
        ) {
            return null
        }

        if (
            parsed.category !== 'all' &&
            parsed.category !== 'IMAGE' &&
            parsed.category !== 'VIDEO' &&
            parsed.category !== 'TOOL' &&
            parsed.category !== 'MUSIC'
        ) {
            return null
        }

        return parsed as HeaderPopoverPanelHandoff
    } catch {
        return null
    }
}
